module.exports = __webpack_public_path__ + "img/valvula.f24c32c5.png";